export function buildTradingServersRowsModel(dtoRows) {
  return dtoRows.map((item) => ({
    id: item.id,
    tradingPlatform: item.tradingPlatform,
    name: item.name,
    description: item.description,
    dsn: item.dsn,
    hasManagerToken: item.hasManagerToken,
    dealerLogin: item.dealerLogin,
    dealerPassword: item.dealerPassword,
    dealerDsn: item.dealerDsn,
    proxy: item.proxy,
    accountTypes: Array.isArray(item.accountTypes) ? item.accountTypes : [],
  }));
}

export function buildPlatformLabelMap(platformOptions) {
  const map = new Map();
  (platformOptions || []).forEach((option) => {
    map.set(String(option.value || '').trim(), String(option.label || option.value || '').trim());
  });
  return map;
}

export function buildEmptyTradingServerForm(platform = '', capabilities = {}) {
  return {
    tradingPlatform: platform,
    capabilities,
    name: '',
    description: '',
    dsn: '',
    managerToken: '',
    hasManagerToken: false,
    dealerLogin: '',
    dealerPassword: '',
    dealerDsn: '',
    proxy: '',
    accountTypes: capabilities.allowedAccountTypes?.length === 1 ? [...capabilities.allowedAccountTypes] : [],
  };
}
